// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

const getUserEmail = async ({
    test,
}: {
    test: boolean,
}): Promise<string | null> => {
    const functions = getFunctions();
    const handleGetUserEmail = httpsCallable<
        Record<
            string,
            boolean
        >,
        string | null
    >(
        functions,
        'getUserEmail',
    );
    return handleGetUserEmail({
        test,
    }).then((result) => {
        const userEmail = result.data as string | null;
        return userEmail;
    }).catch((err) => {
        throw err;
    });
};

export default getUserEmail;
